/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { Milestone } from './Milestone';
import {
    MilestoneFromJSON,
    MilestoneFromJSONTyped,
    MilestoneToJSON,
    instanceOfMilestone,
} from './Milestone';

/**
 * A task entry within an experience's catalog.
 * @export
 * @interface TaskCatalogEntry
 */
export interface TaskCatalogEntry {
    /**
     * Experience-scoped identifier for the task.
     * @type {string}
     * @memberof TaskCatalogEntry
     */
    entryId: string;
    /**
     * Display title for the catalog entry.
     * @type {string}
     * @memberof TaskCatalogEntry
     */
    name: string;
    /**
     * Subtitle shown with the task to provide added context.
     * @type {string}
     * @memberof TaskCatalogEntry
     */
    subheading: string;
    /**
     * Instructions visible to educators and students.
     * @type {string}
     * @memberof TaskCatalogEntry
     */
    instructions: string;
    /**
     * Optional assets that represent the task.
     * @type {Array<string>}
     * @memberof TaskCatalogEntry
     */
    assetIds?: Array<string>;
    /**
     * Optional milestones providing partial grading breakdowns.
     * @type {Array<Milestone>}
     * @memberof TaskCatalogEntry
     */
    milestones?: Array<Milestone>;
}


/**
 * Check if a given object implements the TaskCatalogEntry interface.
 */
export function instanceOfTaskCatalogEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entryId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "subheading" in value;
    isInstance = isInstance && "instructions" in value;
    return isInstance;
}

export function TaskCatalogEntryFromJSON(json: any): TaskCatalogEntry {
    return TaskCatalogEntryFromJSONTyped(json, false);
}

export function TaskCatalogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskCatalogEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'entryId': json['entryId'],
        'name': json['name'],
        'subheading': json['subheading'],
        'instructions': json['instructions'],
        'assetIds': !exists(json, 'assetIds') ? undefined : json['assetIds'],
        'milestones': !exists(json, 'milestones') ? undefined : ((json['milestones'] as Array<any>).map(MilestoneFromJSON)),
    };
}

export function TaskCatalogEntryToJSON(value?: TaskCatalogEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'entryId': value.entryId,
        'name': value.name,
        'subheading': value.subheading,
        'instructions': value.instructions,
        'assetIds': value.assetIds === undefined ? undefined : value.assetIds,
        'milestones': value.milestones === undefined ? undefined : ((value.milestones as Array<any>).map(MilestoneToJSON)),
    };
}

